var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo.isSystemAdministrator
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-new": false,
              "show-print": false,
              "show-delete": false,
              "show-save": true,
              "show-lock": false,
              "show-cancel": true,
              "show-edit": true,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _vm.entity
                  ? _c("flexiquote-module-side-menu", {
                      attrs: { "entity-name": _vm.entity.modDesc },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column" },
              [
                _vm.entity
                  ? _c("router-view", {
                      key: _vm.$route.fullPath,
                      ref: "currentChild",
                      model: {
                        value: _vm.entity,
                        callback: function ($$v) {
                          _vm.entity = $$v
                        },
                        expression: "entity",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }